import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { CHECKOUT_URL } from '../utils/checkout';
export function PricingSection() {
  return <section id="offerta" className="scroll-mt-4 bg-sand px-4 py-16 md:py-24" data-id="element-160" data-mp="1ei8nbq1m3lum">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-161" data-mp="1eg5nkeanqecp">
        <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-162" data-mp="1ja0g8788q3nx">
          UNA SOLA OFFERTA, TUTTO INCLUSO
        </p>
        <h2 className="mb-10 text-3xl font-bold tracking-tight text-petrol md:text-4xl" data-id="element-163" data-mp="1ncwujlqqzdm2">Il pacchetto completo</h2>
        <div className="rounded-2xl border border-line bg-white p-7 shadow-lift md:p-11" data-id="element-164" data-mp="1x8ztyju7sy5b">
          <div className="space-y-4 text-left" data-id="element-165" data-mp="227t545m14d2b">
            <PriceLine label="6 Volumi Completi · 480 pagine illustrate" price="197 €" data-id="element-166" data-mp="226i6ek7fxvi2" />
            <PriceLine label="5 Bonus Esclusivi" price="100 €" data-id="element-167" data-mp="2vqqp9s9i8vi" />
            <div className="flex items-center justify-between gap-4 pt-2 text-sm font-semibold text-petrol" data-id="element-168" data-mp="7tihg0h67oy4">
              <span data-id="element-169" data-mp="1mh6jsx2eqy4e">VALORE TOTALE</span>
              <span className="text-muted line-through" data-id="element-170" data-mp="1mi97kw4fokg3">297 €</span>
            </div>
          </div>
          <div className="my-8 border-y border-line py-8" data-id="element-171" data-mp="1hodgmdml7xuf">
            <p className="font-note text-[10px] font-semibold tracking-[0.2em] text-sage" data-id="element-172" data-mp="1cqbx5rl91wif">IL TUO PREZZO OGGI</p>
            <p className="mt-3 font-heading text-6xl font-bold leading-none tracking-tight text-terracotta md:text-7xl" data-id="element-173" data-mp="17sjvw6ypsy1k">
              19 <span className="text-4xl md:text-5xl" data-id="element-174" data-mp="25f0pp288otik">€</span>
            </p>
            <p className="mt-3 font-note text-xs text-muted" data-id="element-175" data-mp="20hhao03pwcpk">Pagamento unico · Nessun abbonamento</p>
          </div>
          <CTAButton href={CHECKOUT_URL} className="w-full py-5 text-base md:text-lg" data-id="element-176" data-mp="1vg1t4i0r0obx" />
          <p className="mt-5 font-note text-xs leading-relaxed text-muted" data-id="element-177" data-mp="1repzm1er7iyg">
            Download immediato in PDF subito dopo il pagamento · Pagamento sicuro con carta o PayPal · Garanzia
            soddisfatti o rimborsati di 30 giorni
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-line pb-4 text-sm" data-id="element-178" data-mp="mh4exg14g0oo">
      <span className="text-ink" data-id="element-179" data-mp="7kddl17w0ewf">{label}</span>
      <span className="whitespace-nowrap font-semibold text-petrol" data-id="element-180" data-mp="7jbymlnr389f">{price}</span>
    </div>;
}